<template lang="html">
  <div>
    <div class="content-i">
      <div class="content-box" style="padding-bottom: 0px;">
        <div class="element-wrapper" style="padding-bottom: 0px;">
          <h6 class="element-header">{{ t('titleAddCustomers','titleAddCustomers') }}</h6>
          <div class="element-box">
            <div class="element-info">
              <div class="row align-items-center">
                <div class="col-sm-8">
                  <div class="element-info-with-icon">
                    <div class="element-info-icon">
                      <fontAwesomeIcon :icon="['fa', 'user-edit']" size="1x" class=""/>
                    </div>
                    <div class="element-info-text">
                      <h5 class="element-inner-header">{{ t('titleAddCustomers','titleAddCustomers') }}</h5>
                      <div class="element-inner-desc">{{ t('addOrUpdateCustomersInBulk', 'addOrUpdateCustomersInBulk') }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <form v-on:submit.prevent="addOrUpdateCustomers">
                <h6 class="element-header" >{{t('labelARUploadTemplates','labelARUploadTemplates')}}</h6>
                <div class="col-12 row mb-5">
                  <div class="col-sm-12 col-md-6 col-lg-4 px-0">
                    <!-- Download sample CSV template -->
                    <div class="default-template-dwnl d-flex align-items-center">
                      <span style="font-size: 16px">{{ t('downloadSampleCSVTemplateText', 'downloadSampleCSVTemplateText') }} </span>
                      <span class="ml-2 download-link btn btn-primary" @click="downloadARDefaultTemplate()">{{ t('hereText', 'hereText') }}</span>
                    </div>  
                  </div>
                </div>
                <h6 class="element-header" >{{t('labelUploadSettings','labelUploadSettings')}}</h6>
                <div class="col-12 row mb-5">
                  <div class="col-sm-12 col-md-6 col-lg-4">
                    <!-- Import CSV file -->
                    <b-form-group >
                      <label :for="'customer-csv'" class="">{{ t('labelCSVFile', 'labelCSVFile') }}</label>
                      <b-form-file
                        id="customer-csv"
                        accept=".csv"
                        v-model="customerCSV"
                        :placeholder="t('chooseOrDropFile', 'chooseOrDropFile')"
                        :drop-placeholder="t('dropFileHere')"
                        @change="clearOldFile($event)"
                        required
                        ref="ar_file_input"
                      ></b-form-file>
                      <div v-if=" customerCSV && (typeof customerCSV == 'object')" class="mt-1 file-upload">
                        <span v-if=" customerCSV.name">
                          <fontAwesomeIcon :icon="['fas', 'file']" size="1x" />
                          <span class="pl-1"> {{  customerCSV.name }} </span>
                          <span v-if=" customerCSV.size > 1000000" class="pl-2 text-danger">{{t('theFileIsTooBig','theFileIsTooBig')}} ( {{  customerCSV.size }} {{t('labelBytes','labelBytes')}})</span>
                          <span v-else class="text-success">{{t('selected', 'selected')}}</span>
                        </span>
                      </div>
                    </b-form-group>
                  </div>

                  <div class="col-sm-12 col-md-6 col-lg-4">
                    <!-- User doc type -->
                    <b-form-group>
                      <label :for="'user-doc-types'" class="">{{ t('userDocumentType', 'userDocumentType') }}</label>
                      <select id="user-doc-types" v-model="customersData.userDocType" class="form-control custom-select text-capitalize" multiple size="4">
                        <option :value="0" selected>{{t('selectAll','selectAll') }} - {{t('multiSelectUseDesc','multiSelectUseDesc')}}</option>
                        <option v-for="(docType, key) in userDocTypes" :value="docType.id" :key="key">{{ docType.name }}</option>
                      </select>
                    </b-form-group>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-4">
                    <b-form-group>
                      <b-form-checkbox id="first-row-contains-headings" :unchecked-value="undefined" v-model="customersData.headings" class="col-sm-12 col-md-6 col-lg-6">
                        {{t('firstRowContainsHeadings', 'firstRowContainsHeadings')}}
                      </b-form-checkbox>
                    </b-form-group>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-12">
                    <b-form-group>
                      <b-form-radio-group id="delimiters" v-model="customersData.delimiters" name="radio-sub-component" class="col-sm-12 col-md-6 col-lg-6">
                        <b-form-radio :value="'comma'">{{t('commaDelimitedData', 'commaDelimitedData')}}</b-form-radio>
                        <b-form-radio :value="'tab'">{{t('tabDelimitedData','tabDelimitedData')}}</b-form-radio>
                      </b-form-radio-group>
                    </b-form-group>
                  </div>
                </div>

                <h6 class="element-header" >{{t('customerInformation','customerInformation')}}</h6>
                <div class="col-12 row mb-5">
                  <div class="col-sm-12 col-md-6 col-lg-4">
                    <div class="form-group">
                      <label :for="'customer-reference'" label-cols="3" class="inline">{{ t('customerReference', 'customerReference') }}<span class="req-star">*</span></label>
                      <select required id="customer-reference" v-model="arData.customerReference" class="form-control custom-select text-capitalize">
                        <option v-for="(col, key) in colOptions" :value="col.value" :key="key">{{ col.name }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-4">
                    <div class="form-group">
                      <label :for="'customer-name'" class="">{{ t('customerName', 'customerName') }}<span class="req-star">*</span></label>
                      <select required id="customer-name" v-model="arData.customerName" class="form-control custom-select text-capitalize">
                        <option v-for="(col, key) in colOptions" :value="col.value" :key="key">{{ col.name }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-4">
                    <div class="form-group">
                      <label :for="'customer-name'" class="">{{ t('parentCustomerRefLabel', 'parentCustomerRefLabel') }}</label>
                      <select id="customer-name" v-model="arData.parentCustomerRef" class="form-control custom-select text-capitalize">
                        <option v-for="(col, key) in colOptions" :value="col.value" :key="key">{{ col.name }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-12 row mx-0">
                    <b-form-checkbox id="add-customers-not-in-the-system" :unchecked-value="undefined" v-model="customersData.addCustomersNotInSys" class="col-sm-12 col-md-6 col-lg-4 ml-1">
                      {{t('addCustomersNotInTheSystem', 'addCustomersNotInTheSystem')}}
                    </b-form-checkbox>
                    <b-form-checkbox id="overwrite-existing-names" :unchecked-value="undefined" v-model="customersData.overwriteExistingNames" class="col-sm-12 col-md-6 col-lg-4 ml-1">
                      {{t('overwriteExistingNames', 'overwriteExistingNames')}}
                    </b-form-checkbox>
                  </div>
                </div>
                <div class="col-12 row mb-5">
                  <div class="col-sm-12 col-md-6 col-lg-4">
                    <div class="form-group">
                      <label :for="'address-1'" class="">{{ t('addressLine1', 'addressLine1') }}<span class="req-star">*</span></label>
                      <select id="address-1" required v-model="arData.addressLine1" class="form-control custom-select text-capitalize">
                        <option v-for="(col, key) in colOptions" :value="col.value" :key="key">{{ col.name }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-4">
                    <div class="form-group">
                      <label :for="'address-2'" class="">{{ t('addressLine2', 'addressLine2') }}</label>
                      <select id="address-2" v-model="arData.addressLine2" class="form-control custom-select text-capitalize">
                        <option v-for="(col, key) in colOptions" :value="col.value" :key="key">{{ col.name }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-4">
                    <div class="form-group">
                      <label :for="'other-state'" class="">{{ t('state', 'state') }}<span class="req-star">*</span></label>
                      <select id="other-state" required v-model="arData.state" class="form-control custom-select text-capitalize">
                        <option v-for="(col, key) in colOptions" :value="col.value" :key="key">{{ col.name }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-4">
                    <div class="form-group">
                      <label :for="'other-city'" class="">{{ t('city', 'city') }}<span class="req-star">*</span></label>
                      <select id="other-city" required v-model="arData.city" class="form-control custom-select text-capitalize">
                        <option v-for="(col, key) in colOptions" :value="col.value" :key="key">{{ col.name }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-4">
                    <div class="form-group">
                      <label :for="'postcode'" class="">{{ t('postcode', 'postcode') }}<span class="req-star">*</span></label>
                      <select id="postcode" required v-model="arData.postcode" class="form-control custom-select text-capitalize">
                        <option v-for="(col, key) in colOptions" :value="col.value" :key="key">{{ col.name }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-4">
                    <div class="form-group">
                      <label :for="'telephone-1'" class="">{{ t('mainTelephone', 'mainTelephone') }}</label>
                      <select id="telephone-1" v-model="arData.telephonenumber" class="form-control custom-select text-capitalize">
                        <option v-for="(col, key) in colOptions" :value="col.value" :key="key">{{ col.name }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-6">
                    <b-form-checkbox id="overwrite-existing-address-postal" :unchecked-value="undefined" v-model="customersData.overwriteExistingPostalAddress" class="col-lg-6">
                      {{t('overwriteExistingAddress', 'overwriteExistingAddress')}}
                    </b-form-checkbox>
                  </div>
                </div>
                <div class="col-12 row mb-3">
                  <div class="col-sm-12 col-md-6 col-lg-4">
                    <div class="form-group">
                      <label :for="'country-code'" class="">{{ t('billingCountryCodeLabel', 'billingCountryCodeLabel') }}<span class="req-star">*</span></label>
                      <select required id="country-code" v-model="arData.countryCode" class="form-control custom-select text-capitalize">
                        <option v-for="(col, key) in colOptions" :value="col.value" :key="key">{{ col.name }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-4">
                    <div class="form-group">
                      <label :for="'currency-code'" class="">{{ t('billingCurrencyCodeLabel', 'billingCurrencyCodeLabel') }}<span class="req-star">*</span></label>
                      <select required id="currency-code" v-model="arData.currencyCode" class="form-control custom-select text-capitalize">
                        <option v-for="(col, key) in colOptions" :value="col.value" :key="key">{{ col.name }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-4">
                    <div class="form-group">
                      <label :for="'other-language'" class="">{{ t('language', 'language') }}<span class="req-star">*</span></label>
                      <select required id="other-language" v-model="arData.language" class="form-control custom-select text-capitalize">
                        <option v-for="(col, key) in colOptions" :value="col.value" :key="key">{{ col.name }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-4">
                    <div class="form-group">
                      <label :for="'eu-vat-id'" class="">{{ t('euVatIdLabel', 'euVatIdLabel') }}<span class="req-star">*</span></label>
                      <select required id="eu-vat-id" v-model="arData.euVatId" class="form-control custom-select text-capitalize">
                        <option v-for="(col, key) in colOptions" :value="col.value" :key="key">{{ col.name }}</option>
                      </select>
                    </div>
                  </div>
                </div>

                <h6 class="element-header" >{{t('contactInformation','contactInformation')}}</h6>
                <div class="col-12 row mb-3">
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label :for="'first-name'" class="">{{ t('firstName', 'firstName') }}<span class="req-star">*</span></label>
                      <select required id="first-name" v-model="arData.firstName" class="form-control custom-select text-capitalize">
                        <option v-for="(col, key) in colOptions" :value="col.value" :key="key">{{ col.name }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label :for="'last-name'" class="">{{ t('lastName', 'lastName') }}<span class="req-star">*</span></label>
                      <select required id="last-name" v-model="arData.lastName" class="form-control custom-select text-capitalize">
                        <option v-for="(col, key) in colOptions" :value="col.value" :key="key">{{ col.name }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-4">
                    <div class="form-group">
                      <label :for="'email-primary'" label-cols="3" class="inline">{{ t('primaryEmail', 'primaryEmail') }}<span class="req-star">*</span></label>
                      <select required id="email-primary" v-model="arData.emailPrimary" class="form-control custom-select text-capitalize">
                        <option v-for="(col, key) in colOptions" :value="col.value" :key="key">{{ col.name }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-4">
                    <div class="form-group">
                      <label :for="'telephone-2'" class="">{{ t('telephoneNumber2', 'telephoneNumber2') }}<span class="req-star">*</span></label>
                      <select required id="telephone-2" v-model="arData.telephonenumber2" class="form-control custom-select text-capitalize">
                        <option v-for="(col, key) in colOptions" :value="col.value" :key="key">{{ col.name }}</option>
                      </select>
                    </div>
                  </div>
                </div>

                
                <template>
                  <h6 class="element-header mb-3">{{ t('managedARHeader','managedARHeader') }}</h6>
                  <template>
                    <div class="col-12 row mb-1">
                      <div class="col-sm-12 col-md-6 col-lg-4">
                        <div class="form-group">
                          <label :for="'line-of-credit'" class="">{{ t('lineOfCreditLabel', 'lineOfCreditLabel') }}<span class="req-star">*</span></label>
                          <select required id="line-of-credit" v-model="arData.lineOfCredit" class="form-control custom-select text-capitalize">
                            <option v-for="(col, key) in colOptions" :value="col.value" :key="key">{{ col.name }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-sm-12 col-md-6 col-lg-4">
                        <div class="form-group">
                          <label :for="'projected-sales'" class="">{{ t('projectedMonthlySalesLabel', 'projectedMonthlySalesLabel') }}</label>
                          <select id="projected-sales" v-model="arData.projectedMonthlySales" class="form-control custom-select text-capitalize">
                            <option v-for="(col, key) in colOptions" :value="col.value" :key="key">{{ col.name }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-sm-12 col-md-6 col-lg-4">
                        <div class="form-group">
                          <label :for="'payment-terms'" class="">{{ t('paymentTerms', 'paymentTerms') }}</label>
                          <select id="payment-terms" v-model="arData.paymentTerms" class="form-control custom-select text-capitalize">
                            <option v-for="(col, key) in colOptions" :value="col.value" :key="key">{{ col.name }}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </template>
                </template>

                <transition name="fade">
                  <ResponseInfo v-if="(getResponseInfo.responseName == 'addCustomers') && (getResponseInfo.status == 'error')" class="mt-3"/>
                </transition>

                <div class="col-12 d-flex justify-content-end px-4">
                  <div class="col-12 d-flex justify-content-end align-items-center" v-if="arFieldsInvalid">
                    <small class="text-danger">{{ t('mandatoryARFieldsMissing', 'mandatoryARFieldsMissing') }}</small>
                  </div>
                  <button v-if="!isBusy" :disabled="!checkARFieldValidation" class="btn btn-primary" type="submit" >{{ t('uploadBtn','uploadBtn') }}</button>
                  <b-button v-else variant="primary" disabled>
                    <b-spinner small type="grow"></b-spinner>
                    {{ t('searchCustomersBtn','searchCustomersBtn') }}
                  </b-button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <AddCustomersResultModal :stats="stats"></AddCustomersResultModal>
    <div v-if="modalOpen" class="modal-backdrop show"></div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { clientShortName } from '@/helpers/clientShortName.js'
import moment from 'moment'
import ResponseInfo from '@/components/ResponseInfo.vue'
import AddCustomersResultModal from '@/components/AddCustomers/ModalAddCustomersResult.vue'
import { backendUrl } from '@/helpers/backendUrl.js'

    export default {
    name: 'add_customers_bulk_managed_ar',
    data() {
      return {
        colOptions: [
          { name: 'A column', value: 1},
          { name: 'B column', value: 2},
          { name: 'C column', value: 3},
          { name: 'D column', value: 4},
          { name: 'E column', value: 5},
          { name: 'F column', value: 6},
          { name: 'G column', value: 7},
          { name: 'H column', value: 8},
          { name: 'I column', value: 9},
          { name: 'J column', value: 10},
          { name: 'K column', value: 11},
          { name: 'L column', value: 12},
          { name: 'M column', value: 13},
          { name: 'N column', value: 14},
          { name: 'O column', value: 15},
          { name: 'P column', value: 16},
          { name: 'Q column', value: 17},
          { name: 'R column', value: 18},
          { name: 'S column', value: 19},
          { name: 'T column', value: 20},
          { name: 'U column', value: 21},
          { name: 'V column', value: 22},
          { name: 'W column', value: 23}
          //{ name: 'Z column', value: 'Z'}
        ],
        // we set up the form with it's default values
        customersData: {
          userDocType: [0],
          headings: true,
          delimiters: 'comma',
          customerReference: 1,
          addCustomersNotInSys: true,
          appendToExistingEmail: true,
          overwriteExistingPostalAddress: false
        },
        arData: {
          euVatId: null,
          countryCode: null,
          currencyCode: null,
          enrollmentCommunity: null,
          lineOfCredit: null,
          projectedMonthlySales: null,
          paymentTerms: null,
          chainFinanceEnabled: null,
          firstName: null,
          lastName: null,
          parentCustomerRef: null
        },
        customerCSV: null,
        stats: null,
        modalOpen: false,
        isBusy: false,
        arFieldsInvalid: false
      }
    },
    computed:{
        ...mapGetters(['allTemplateDetails', 'getUserDetails', 'getResponseInfo']),
        userDocTypes() {
          return this.$store.getters['customerStore/getUserDocumentTypes']
        },
        clientCustomerDataSetup() {
          return this.$store.getters['customerStore/getCustomerDataSetup']
        },
        userLevel() {
          return this.$store.getters.getUserLevel
        },
        checkARFieldValidation() {
          return true
          // false = invalid
          // true = valid
          if(this.arData.chainFinanceEnabled) {
            if(this.arData) {
              for (const [key, value] of Object.entries(this.arData)) {
                if(!value) {
                  this.arFieldsInvalid = true
                  return false
                }
              }
            }
          }

          this.arFieldsInvalid = false
          return true
        }
    },
    methods: {
      addOrUpdateCustomers() {
        this.isBusy = true

        let formData = new FormData()
        formData.append('file', this.customerCSV)

        let form = JSON.stringify(this.customersData)
        formData.append('form', form)

        let arData = JSON.stringify(this.arData)
        formData.append('arForm', arData)

        this.$store.dispatch('integrationStore/uploadARCustomers', formData)
        .then(response => {
          this.isBusy = false
          if(response) {
            this.stats = response
            this.modalOpen = true
            this.customerCSV = null
            this.$root.$emit('bv::show::modal', 'addCustomersSummaryResult')

            if(this.$refs.ar_file_input) {
              this.$refs.ar_file_input.value = null
            }
          }
        }, this)
      },
      
      getChainFinanceStatus() {
        this.$store.dispatch('integrationStore/getChainFinanceStatus', null)
        .then(response => {
          this.arData.chainFinanceEnabled = response 
        })
      },

      clearOldFile(event) {
        if(this.customerCSV) {
          this.customerCSV = null
        }

        this.customerCSV = event.target.files
      },
      downloadARDefaultTemplate() {
        this.downloadUrl = backendUrl() + '/managedAR/downloadManagedARDefaultTemplate' 

        var fileLink = document.createElement('a');
        fileLink.target = "_blank";
        fileLink.href = this.downloadUrl;
        document.body.appendChild(fileLink);

        fileLink.click();
      }
    },
    created() {
      this.$store.dispatch('customerStore/getUserDocumentTypes')
      this.$store.dispatch('customerStore/getCustomerDataSetup')
      this.getChainFinanceStatus()
    },
    components: {
      ResponseInfo,
      AddCustomersResultModal
    }
}
</script>

<style lang="css" scoped>
  #delimiters {
    padding: 0;
  }
  .req-star {
    color: red;
  }
  .download-link {
    cursor: pointer;
    font-weight: 600;
  }
</style>
